import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("scrolling-content", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateScrollingContent = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animateScrollingContent?.destroy();
  },
});
